import { render } from "./TenantJobsFrame.vue?vue&type=template&id=126834bc&scoped=true"
import script from "./TenantJobsFrame.vue?vue&type=script&lang=js"
export * from "./TenantJobsFrame.vue?vue&type=script&lang=js"

import "./TenantJobsFrame.vue?vue&type=style&index=0&id=126834bc&scoped=true&lang=css"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126834bc"]])

export default __exports__